import React, { useState } from "react";
import { makeStyles, Box } from "@material-ui/core";
import AddUserComponent from "./AddUserComponent";
// import ImportUsersComponent from "./import/ImportUsersComponent";
// import UserPoolSelectorButton from "./UserPoolSelectorButton";
import UsersTable from "./UsersTable";

const useStyles = makeStyles(() => ({
  mainContent: {
    padding: "40px 80px"
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end"
  },
  actionButtonsContainer: {
    display: "flex",
    flexDirection: "row-reverse"
  },
  tableContainer: {
    marginTop: "10px"
  }
}));

// eslint-disable-next-line react/prop-types
export default function UsersComponent() {
  const classes = useStyles();
  const [refreshTableKey, setRefreshTableKey] = useState(0);
  // const [userPool, setUserPool] = useState("clients");

  const refreshTable = () => {
    setRefreshTableKey(refreshTableKey + 1);
  };

  return (
    <div className={classes.mainContent}>
      <Box component="div" className={classes.actionsContainer}>
        {/* <UserPoolSelectorButton onUserPoolChange={setUserPool} /> */}
        <Box component="div" className={classes.actionButtonsContainer}>
          <AddUserComponent
            onSuccess={refreshTable}
            // userPool={userPool}
          />
          {/* <ImportUsersComponent
            onSuccess={refreshTable}
            // userPool={userPool}
          /> */}
        </Box>
      </Box>
      <Box component="div" className={classes.tableContainer}>
        <UsersTable
          refreshKey={refreshTableKey}
          // userPool={userPool}
        />
      </Box>
    </div>
  );
}
